module.exports = {
      id: "online-news-usage",
      viewBox: "0 0 56.84 35.647",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#online-news",
      toString: function () {
        return this.url;
      }
    }